module.exports = __webpack_public_path__ + "static/media/dashboard_selected.85b57dde.svg";